<template>
  <nav class="ml-6 ma-0">
    <span class="trace">ToolbarWq.vue</span>

    <v-row justify="end">
      <v-spacer />
      <v-col
        class="text-right"
        cols="12"
        sm="12"
      >
        <v-btn
          small
          class="mr-2 small"
          @click="learnClick"
        >
          Learn<span class="hidden-md-and-down"> More</span>
        </v-btn>
        <v-btn
          small
          class="mr-2 small"
          @click="pledgeClick"
        >
          <span class="hidden-md-and-down">&nbsp;</span>Endorse&nbsp;
        </v-btn>

        <v-btn
          small
          class="mr-2 small"
          @click="mitigateClick"
        >
          Mitigation<span class="hidden-md-and-down">  Programs</span>
        </v-btn>
        <v-btn
          small
          class="mr-2 small"
          @click="adaptClick"
        >
          Adaptation<span class="hidden-md-and-down">  Programs</span>
        </v-btn>

        <v-btn
          small
          class="mr-2 small"
          @click="neighborhoodClick"
        >
          Neighborhood<span class="hidden-md-and-down">  Programs</span>
        </v-btn>

        <!--
          :to="{
            name: 'WaterRo',
          }"
        -->
      </v-col>
    </v-row>
  </nav>
</template>

<script>
  export default {
    name: 'SplashWQ',

    components: {
      // WaterRo: () => import('@/views/projects/water/WaterRo'),
    },

    methods: {
      learnClick: function (event) {
        this.$router.push({ name: 'Health' })
        // alert('This will teach more about water quality')
      },

      pledgeClick: function (event) {
        alert('This is where you can indicate you will be a Water Protectors to the extent you feel you can.')
      },

      mitigateClick: function (event) {
        alert('This will show Mitigation suggestions')
      },
      adaptClick: function (event) {
        // https://router.vuejs.org/guide/essentials/navigation.html
        this.$router.push({ name: 'Adapt' })
        // this.$router.push({ path: 'waterQuality/adapt' })
        // alert('This will show an RO system')
        /*
        // `this` inside methods points to the Vue instance
        alert('Hello ' + this.name + '!')
        // `event` is the native DOM event
        if (event) {
          alert(event.target.tagName)
        }
        */
      },
      neighborhoodClick: function (event) {
        this.$router.push({ name: 'Neighborhood' })
        // alert('This is where you will be able to read more about Water Protectors program designed to focus on individual neighborhoods and the water safety and quality in the neighborhood specifically.')
      },

    },

  }
</script>
